import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { Text } from '@atlaskit/primitives/compiled';
import CategoryTag from '@atlassian/jira-business-categories/src/ui/category-form/category-tag/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import type { CategoryGroupHeader$key } from '@atlassian/jira-relay/src/__generated__/CategoryGroupHeader.graphql';
import messages from './messages.tsx';

export type Props = {
	categoryGroupHeader: CategoryGroupHeader$key | null;
};

export const CategoryGroupHeader = ({ categoryGroupHeader }: Props) => {
	const data = useFragment<CategoryGroupHeader$key>(
		graphql`
			fragment CategoryGroupHeader on JiraJqlOptionFieldValue {
				displayName
				option {
					color {
						colorKey
					}
				}
			}
		`,
		categoryGroupHeader,
	);

	const { formatMessage } = useIntl();

	return data != null ? (
		<CategoryTag
			categoryColor={data?.option?.color?.colorKey ?? null}
			categoryName={data?.displayName}
			isInteractive={false}
		/>
	) : (
		<Text>{formatMessage(messages.noCategory)}</Text>
	);
};
